import { useContext } from 'react';
import { Button } from '@gtintel/platform-atoms';
import { PROJECT_ACTIVATED_ID } from '@gtintel/platform-constants';
import { ProjectContext } from '../../../ProjectApp/context';
const ActivateProjectButton = () => {
  const {
    edit
  } = useContext(ProjectContext);
  return <Button kind="primary" testId="activate-project-button" onClick={() => edit({
    status: PROJECT_ACTIVATED_ID
  })}>
      Activate Project
    </Button>;
};
export default ActivateProjectButton;